import { Injectable, inject } from '@angular/core';

import { PermissionsService } from '../permissions/permissions.service';

interface ButtonGroupActionItem {
  label: string;
  permissions?: string[];
  action: () => void;
}

export interface ButtonGroupAction extends ButtonGroupActionItem {
  items?: ButtonGroupActionItem[];
}

@Injectable({ providedIn: 'root' })
export class ButtonGroupActionsService {
  private readonly permissionsService = inject(PermissionsService);

  normalize(action?: ButtonGroupAction): ButtonGroupAction | undefined {
    if (action == null) {
      return undefined;
    }

    if (action.permissions && this.permissionsService.check(action.permissions) === false) {
      return undefined;
    }

    const items = (action.items ?? []).filter((item) => {
      if (item.permissions == null) {
        return true;
      }

      return this.permissionsService.check(item.permissions);
    });

    return { ...action, items };
  }
}
